import React, {useEffect, useState} from "react";
import {Alert, Button, Spin} from "antd";
import {getCertificate, useCertificate} from "../hooks/certificate";
import {useTranslation} from "react-i18next";
import {templateGuidSubject} from "../hooks/template";
import {ResponseSubjectState} from "../hooks";
import { QrReader } from "react-qr-reader";
import {XCircle, Camera} from "react-feather";
import {BackButton} from "./layout/BackButton";


let video: any;

export function ScanQrCode({show, header, onClose, onSuccess}: { show: boolean, header?: string, onClose?: any, onSuccess: any }) {
    const {t} = useTranslation();

    const beforeClose = () => {
        if (video) {
            video.srcObject = null;
            video.mozSrcObject = null;
            video.src = null;
            video = undefined;
        }
    };

    useEffect(() => {
        templateGuidSubject.next(new ResponseSubjectState());
        return beforeClose
    }, [true]);
    const certificateResponse = useCertificate();

    const CAMERA_BACK = 'environment';
    const CAMERA_FRONT = 'user';

    const [notFound, setNotFound] = useState(false);
    const [cameraFacingMode, setCameraFacingMode] = useState(CAMERA_BACK);

    const onScan = (data: any, error: any) => {
        if (data && !certificateResponse.loading) {
            const tmp = data?.text.split('/');
            const certificateId = tmp[tmp.length - 1];
            getCertificate(certificateId, true).then(response => {
                beforeClose();
                !!onClose && onClose();
                onSuccess(response);
            }).catch((error) => {
                console.error(error);
                setNotFound(true)
            });
        }
    };

    if (!show) {
        return null;
    }

    return (
        <div className={header ? 'scan-qr-code with-header' : ''}>
            <Spin spinning={certificateResponse.loading} className={'full-height-spin'}>
                {!!header && <header className="header flex-row">
                  <h2 className={'flex-auto'}>{header}</h2>
                  <Button type={'link'} onClick={onClose}>
                    <XCircle/>
                  </Button>
                </header>}
                <div className={'top-block accent1-background'}>
                    <h1 className={'h1'}><BackButton/><Camera/>{t('scan.title')}</h1>
                </div>
                <div className={'subpage-content'}  onClick={() => setCameraFacingMode(cameraFacingMode === CAMERA_BACK ? CAMERA_FRONT: CAMERA_BACK)}>
                    <QrReader
                        key={cameraFacingMode}
                        ref={(node: any) => {
                            if (node) {
                                video = (document.querySelector('video') || {} as any);
                            }
                        }}
                        constraints={{'facingMode': cameraFacingMode }}
                        className={'qr-reader'}
                        delay={300}
                        onError={console.error}
                        onResult={onScan}
                        style={{width: '100%'}}
                    />
                    {!!notFound && <Alert message={t('certificate.notFound')} type="error"/>}
                </div>
            </Spin>
        </div>
    )
}
